import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const Subtitle = props => (
  <p
    className={classNames({
      subtitle: true,
      centered: props.center,
      [props.className]: props.className
    })}
  >
    {props.children}
    {props.hasEmphasisText ? (
      <span className='emphasis'>
        <small> $</small>
        {props.number}
      </span>
    ) : null}
  </p>
)

Subtitle.propTypes = {
  number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  hasEmphasisText: PropTypes.bool,
  center: PropTypes.bool
}

export default Subtitle



// WEBPACK FOOTER //
// ./src/ui/texts/subtitle.js